import { UsersListEnvelopeSchema } from "@fitties/shared";
import logger from "@logger";
import type { z } from "zod";

/**
 * Parse a callable `{ users }` envelope, then soft-parse each row.
 * Envelope failure throws (ZodError on {@link Error.cause}); invalid rows are dropped with {@link logger.warn}.
 */
export function parseCallableUsersListResponse<TRow>(
  data: unknown,
  functionName: string,
  rowSchema: z.ZodType<TRow>
): TRow[] {
  const envelope = UsersListEnvelopeSchema.safeParse(data);
  if (!envelope.success) {
    throw new Error(`Invalid ${functionName} response: expected { users: [...] }`, {
      cause: envelope.error,
    });
  }

  const valid: TRow[] = [];
  for (const row of envelope.data.users) {
    const parsed = rowSchema.safeParse(row);
    if (parsed.success) {
      valid.push(parsed.data);
      continue;
    }

    logger.warn("Dropping invalid row from Cloud Function response", {
      functionName,
      issues: parsed.error.issues,
    });
  }

  return valid;
}
